import {styled, TableCell, tableCellClasses, TableContainer} from "@mui/material";
import TableRow from "@mui/material/TableRow";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import * as React from "react";

const StyledTableCell = styled(TableCell)(({theme}) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({theme}) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

export default function PublishedHispsInfoDialog(props) {
    const setPublishedHispsDialogOpen= props.setPublishedHispsDialogOpen;
    const publishedHispsDialogOpen = props.publishedHispsDialogOpen;
    const publishedHispsInfo = props.publishedHispsInfo;

    const handleClose = () => {
        setPublishedHispsDialogOpen(false);
    };

    return (
        <div>
            {publishedHispsInfo &&
                <Dialog
                    open={publishedHispsDialogOpen}
                    onClose={handleClose}
                    aria-labelledby="publishedHispsInfo-dialog-title"
                    aria-describedby="publishedHispsInfo-dialog-description"
                    maxWidth='md'
                >
                    <DialogTitle id="publishedHispsInfo-dialog-title">
                        Published Hisps Info
                    </DialogTitle>
                    <DialogContent>
                        <TableContainer component={Paper}>
                            <Table sx={{minWidth: 650, m: 0}} size="small">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell sx={{width: 400}}>HISP</StyledTableCell>
                                        <StyledTableCell></StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {Object.entries(publishedHispsInfo).map(([key, value]) => (
                                        <StyledTableRow
                                            key={key}
                                        >
                                            <StyledTableCell component="th" scope="row">
                                                {key}
                                            </StyledTableCell>
                                            <StyledTableCell>{value}</StyledTableCell>
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>

                    </DialogContent>
                    <DialogActions sx={{display: 'flex', justifyContent: 'center', padding: '0 8px 12px 8px'}}>
                        <Button onClick={handleClose} autoFocus variant='contained'>
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            }
        </div>
    );
}
